module.exports = __webpack_public_path__ + "img/94023.ea936378.svg";